<template>
	<div>
  <Modal title="补休申请单详情" v-model="showCreate" class-name="vertical-center-modal" :mask-closable="false" width="680px" @on-cancel="close()">
    <template>
		 <Tabs value="name1">
			 <TabPane label="补休信息" name="name1">
      <Form ref="leaveFrom" :model="leaveFrom" :rules="ruleLeaveFrom" :label-width="100" label-position="right">
		  <FormItem label="姓名:" prop="name">
			  <Row :gutter="20">
			    <Col span="20">
		    <Input v-model="leaveFrom.name" placeholder="员工姓名" style="width:525px" readonly></Input>
			</Col>
			</Row>
		  </FormItem>
		  <FormItem label="工号:" prop="number">
			  <Row :gutter="20">
			    <Col span="20">
		    <Input v-model="leaveFrom.number"  style="width:525px" placeholder="请输入工号" readonly></Input>
			</Col>
			</Row>
		  </FormItem>
		  <FormItem label="部门:" >
			  <Row :gutter="20">
			    <Col span="20">
					<Input v-model="leaveFrom.departmentText"  style="width:525px" placeholder="请选择部门" readonly></Input>
					<!-- <selectTree v-model="leaveFrom.department" style="width:525px" :treeData="treeData" @on-select-change="selectChange" @on-remove="removeRoot" :showQuery='false' ></selectTree> -->
		    <!-- <Input v-model="leaveFrom.department" style="width:525px" placeholder="请输部门" readonly></Input> -->
			</Col>
			</Row>
		  </FormItem>
		  <FormItem label="岗位:" prop="post">
		  			  <Row :gutter="20">
		  			    <Col span="20">
		    <Select placeholder="请选择岗位"  style="width:525px" v-model="leaveFrom.post">
		      <Option value="">------</Option>
		      <Option v-for="item in postList" :key="item.value" :value="item.value">{{ item.name }}</Option>
		    </Select>
		  			</Col>
		  			</Row>
		  </FormItem>
		  
        <FormItem label="开始时间：" prop="startDate">
          <!-- v-model="leaveFrom.startDate" -->
          <Row :gutter="20">
            <Col span="18">
            <DatePicker type="date" placeholder="请选择开始时间 " style="width: 100%" :editable="false" @on-change="leaveFrom.startDate = $event" :value="leaveFrom.startDate" readonly/>
            </Col>
            <Col span="2">
            <Select v-model="leaveFrom.startDateArea" style="width: 100px;">
              <Option v-for="item in leaveTimeList" :value="item.value" :key="item.name">{{ item.name }}</Option>
            </Select>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="结束时间：" prop="endDate">
          <!-- v-model="leaveFrom.endDate" -->
          <Row :gutter="20">
            <Col span="18">
            <DatePicker type="date" placeholder="请选择结束时间 " style="width: 100%" :editable="false" @on-change="leaveFrom.endDate = $event" :value="leaveFrom.endDate" readonly/>
            <!-- <font>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</font> -->
            </Col>
            <Col span="2">
            <Select v-model="leaveFrom.endDateArea" style="width: 100px;">
              <Option v-for="item in leaveTimeList" :value="item.value" :key="item.name">{{ item.name }}</Option>
            </Select>
            </Col>
          </Row>
        </FormItem>
        <FormItem label="补休时长：" prop="timeCount" >
          <Row :gutter="20">
            <Col span="20">
              <Input type="text" :value="leaveFrom.timeCount" placeholder="加班时长 " style="width:525px" readonly>
              <span slot="append">天</span></Input>
              <Input type="text" v-model="timeCount" style="display: none;" />
            </Col>
          </Row>
        </FormItem>
		<FormItem label="未休事由：" prop="title" style="margin-bottom:5px">
					  <Row :gutter="20">
					    <Col span="20">
		  <Input type="textarea" v-model="leaveFrom.title" placeholder="请输入未休事由 " style="width:525px" readonly/>
					</Col>
					</Row>
		</FormItem>
      </Form>
      <Spin size="large" fix v-if="spinShow"></Spin>
	  </TabPane>
	  <TabPane label="操作日志" name="name2">
		  <Timeline>
		    <TimelineItem v-for="(log ,log_i) in logList" :key="log_i">
		      <div><span class="content">{{log.creatorName}}</span><span class="time">{{log.creationTime | dateformat('yyyy-MM-DD HH:mm:ss') }}</span></div>
		      <p class="content">{{log.content}}</p>
		    </TimelineItem>
		  
		  </Timeline>
		  <div slot="footer">
		    <Button @click="czShow = false" class="close-btn">关闭</Button>
		  </div>
		  
	  </TabPane>
	  </Tabs>
    </template>
	<div slot="footer">
	  <Button @click="close()">关闭</Button>
	  <Button v-show="isExamine" type="success" class="close-btn" @click="examine(leaveId)">通过</button>
	  <Button v-show="isExamine" type="error" class="close-btn" @click="handelSubmit()">不通过</button>
	</div>
	
  </Modal>
  <Modal v-model="optionModel" title="原因" :styles="{top:'140px'}"  @on-ok="examineNoPass(leaveId)" @on-cancel="onClose" width="480">
    <Form ref="examineModel" :label-width="20" :rules="ruleValidate" :model="examineModel">
      <FormItem prop="examineText">
        <Input v-model="examineModel.examineText" type="textarea" placeholder="请输入">
        </Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button @click="onClose">取消</Button>
      <Button type="primary" @click="examineNoPass(leaveId)">确定</Button>
    </div>
  </Modal>
  </div>
</template>
<script>
import {
  examineOverTimeLeave,
  examineOverTimeLeaveNoPass,
} from '../../../api/index'
function endDateFun() {
  return false
}
import Ajax from '../../../lib/ajax'
import selectTree from '../../../components/selectTree/selectTree.vue'
export default {
 components: {
 	  selectTree
 },
  props: {
    showCreate: { type: Boolean, default: false },
    leaveId: { type: Number, default: null },
	leaveTypeList: { type: Array, default: [] },
	postList: { type: Array, default: [] },
	isSelf:{type:Boolean,default:false},
	isExamine:{type:Boolean,default:false}
  },
  data() {
    //判断请假日期
    const validateStartDate = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('日期不能为空'))
      } else {
        callback()
      }
    }
    //判断请假结束日期
    const validateEndDate = (rule, value, callback) => {
      if (value == '') {
        callback(new Error('日期不能为空'))
      } else {
        let start_date = this.leaveFrom.startDate //开始时间
        if (start_date.getTime() > value.getTime()) {
          callback(new Error('结束日期不能小于开始日期'))
        } else {
          callback()
        }
      }
    }
    const validateLeaveType = (rule, value, callback) => {
      if (value === '' || value === undefined || value === null) {
        callback(new Error('请假类型不能为空'))
      } else {
        callback()
      }
    }
    //请假时长
    const validateLeaveTime = (rule, value, callback) => {
      if (value < 0) {
        callback(new Error('请假时长不能小于0'))
      } else {
        callback()
      }
    }
    return {
      spinShow: false,
      url: '',
	  logList: [],
      uploadList: [],
      modalLeave: false,
      BtnDisabled: false,
      alwasyTool: false,
	  amountDay:null,
	  optionModel: false, //弹框
	  btnDisabld: false,
	  treeData : [],
      leaveFrom: {
		name:'',
		post:null,
		department:'',
		number:'',
        title: '',
        userId: 0,
        startDate: '',
		workAgent:'',
        endDate: '',
        startDateArea: '上午',
        endDateArea: '上午',
        leaveType: '',
        timeCount: '',
		isSubmit:false,
		isSelfApply:this.isSelf,
		
      },
      leaveTimeList: [
        { value: '上午', name: '上午' },
        { value: '下午', name: '下午' },
      ],
      examineModel:{
		  id:this.leaveId,
		  examineText:""
	  },
      prev: '', //防抖
      ruleLeaveFrom: {
        title: [
          {
            required: true,
            message: '请假事由不能为空',
            trigger: 'blur',
          },
        ],
        startDate: [
          {
            required: true,
            pattern: /.+/,
            validator: validateStartDate,
            trigger: 'blur',
          },
        ],
        endDate: [
          {
            required: true,
            pattern: /.+/,
            // validator: validateEndDate,
            message: '日期不能为空',
            trigger: 'blur',
          },
        ],
        timeCount: [{ validator: validateLeaveTime, trigger: 'change' }],
        startDateArea: [
          {
            required: true,
            message: '开始时间不能为空',
            trigger: 'blur',
          },
        ],
        endDateArea: [
          {
            required: true,
            message: '结束时间不能为空',
            trigger: 'blur',
          },
        ],
        leaveType: [
          {
            required: true,
            validator: validateLeaveType,
            message: '请假类型不能为空',
            trigger: 'change',
          },
        ],
		name: [
		  { required: true, message: '请输入姓名', trigger: 'blur,change', type: 'string' },
		],
		number: [
		  { required: true, message: '请输入工号', trigger: 'blur,change', type: 'string' },
		],
		post: [{ required: true, message: '请选择岗位', trigger: 'blur,change', type: 'number' }]
      },
	  ruleValidate: {
	    examineText: [{ required: true, message: '请输入不通过原因', trigger: 'change' }],
	  },
    }
  },
  
  methods: {
	async getTree(){
			  let reponse=await Ajax.get('/api/services/app/OrganizationUnit/GetOrganizationUnitTree');
			  // reponse.data.result[0].expand = true;
			  let dataResult = reponse.data.result;
		// let respone = this.$store.state.department.departmentTree;
		this.editeTreeValue(dataResult);
		this.treeData = dataResult;
			
	},
	selectChange(data){
		this.leaveFrom.department = data
	},
	removeRoot(data){
		this.leaveFrom.department = data
	},
	editeTreeValue(data){
		for (let i=0; i<data.length; i++) {
			data[i].title = data[i].displayName
			data[i].value = data[i].id
			if(data[i].children){
				if(data[i].children.length>0){
				   data[i].expand=true
				}
				this.editeTreeValue(data[i].children)
			}
		}
	},
	async getDetail(){
		let data = await this.$Ajax.get(`/api/services/app/OverTimeLeave/GetDetailById`, {
		  params: { id: this.leaveId }
		})
		 this.leaveFrom = data.data.result
		 this.leaveFrom.isSelfApply=this.isSelf
		 this.logList = data.data.result.businessLogList
		 
		 this.getTree()
	},
	async getAuthorityById(){
		let data = await this.$Ajax.get(`/api/services/app/OverTimeLeave/GetAuthorityById`, {
		  params: { id: this.leaveId }
		})
		 this.leaveFrom.post = data.data.result.post
		 this.leaveFrom.department = data.data.result.department
		 this.leaveFrom.departmentText = data.data.result.departmentText
		 this.leaveFrom.name = data.data.result.name
		 this.leaveFrom.number = data.data.result.number
		 this.leaveFrom.userId = data.data.result.userId
		 
		 this.getTree()
	},
	// 关闭弹窗
    close(refresh) {
      this.$refs['leaveFrom'].resetFields()
      this.$emit('close', refresh)
	  
	  this.handleReset('leaveFrom')
    },
    
	examine(leaveId) {
	  this.$Modal.confirm({
	    title: '确认通过吗？',
	    okText: '确认',
	    cancelText: '取消',
	    onOk: async () => {
			this.spinShow = true
	      let res = await examineOverTimeLeave(this.examineModel)
	      if (res.data.success) {
			  this.close(true)
			  this.spinShow = false
	        this.$Message.success({ content: '确认成功', duration: 5 })
	      } else {
			  this.close(true)
			  this.spinShow = false
	        this.$Message.error({ content: '确认失败', duration: 5 })
	      }
	    },
	  })
	},
	examineNoPass(leaveId) {
	  this.$refs['examineModel'].validate(async (valid) => {
	    if (valid) {
			this.spinShow = true
	      let res = await examineOverTimeLeaveNoPass(this.examineModel)
	      if (res.data.success) {
			  this.close(true)
			  this.spinShow = false
	        this.$Message.success({ content: '确认成功', duration: 5 })
	      } else {
			  this.close(true)
			  this.spinShow = false
	        this.$Message.error({ content: '确认失败', duration: 5 })
	      }
		  }})
	},
	//意见弹框
	optionOk(data) {
	  let now = Date.now()
	
	  if (this.prev == '' || now - this.prev >= 2300) {
	    this.prev = now
	  } else {
	    return
	  }
	  this.$refs['examineModel'].validate((valid) => {
	    if (this.btnFlog === false) {
	      //否决
	      if (valid) {
	        this.onWithdraw()
	      }
	    } else {
	      //同意
	      //处理数据
	      if (
	        this.opinionObj.dertakeDepartmentIds &&
	        this.opinionObj.dertakeDepartmentIds.length > 0
	      ) {
	        this.opinionObj.undertakeDepartmentIds = this.opinionObj.dertakeDepartmentIds.toString()
	      } else {
	        this.opinionObj.undertakeDepartmentIds = ''
	      }
	
	      if (valid) {
	        this.onOk()
	      }
	    }
	  })
	},
	//判断点击操作
	handelSubmit(flog) {
	  this.optionModel = true
	},
	//关闭抽屉
	onClose() {
	  this.optionModel = false
	  this.close(true)
	},
    submit() {},
    //清空表单验证
    handleReset(name) {
      this.$refs[name].resetFields()

      this.leaveFrom = {
        name:'',
        post:null,
        department:'',
        number:'',
        title: '',
        userId: 0,
        startDate: '',
        workAgent:'',
        endDate: '',
        startDateArea: '',
        endDateArea: '',
        leaveType: '',
        timeCount: '',
        isSubmit:false,
        isSelfApply:true,
      }
      this.BtnDisabled = false
    },
    
    //提示弹窗
    tpis(type, content) {
      this.$Message[type]({
        background: true,
        content: content,
      })
    },
    //计算时长
    async computedTime() {
      let time = {
        startDate: this.leaveFrom.startDate,
        endDate: this.leaveFrom.endDate,
        startDateArea: this.leaveFrom.startDateArea,
        endDateArea: this.leaveFrom.endDateArea,
      }
      await this.$Ajax.post(`/api/services/app/OverTimeLeave/CalcTimeCount`, time).then((res) => {
        let t = res.data.result
        this.leaveFrom.timeCount = t
        return t
      })
      return 0
    },
    
  },
  computed: {
    // 定义计算属性totalPrice
    timeCount: function () {
      if (
        this.leaveFrom.endDateArea != '' &&
        this.leaveFrom.startDate != '' &&
        this.leaveFrom.endDate != '' &&
        this.leaveFrom.startDateArea != ''
      ) {
        this.computedTime()
      } else {
        return 0
      }
    },
  },
  mounted() {
	  if(this.leaveId<=0 || this.leaveId==null){
	  		  this.getAuthorityById()
	  }
	  else{
	  		  this.getDetail()
	  }
  },

}
</script>

<style lang="less" scoped="scoped">
.ivu-spin-fix {
  z-index: 99999999;
}
.vertical-center-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .input_heigth {
    line-height: 30px;
    margin: 10px;
  }
}

.ivu-form-item {
  margin-bottom: 16px;
}

.disabled {
  padding-left: 5px;
  background: #f3f3f3;
}

.forms {
  padding: 20px 30px;
}
.tips {
  color: #f60;
  font-size: 14px;
  // transform: scale(0.6);
  // display: inline-block;
  // position: absolute;
  // left: 21px;
  // top: 10px;
  // padding: 5px 0px;
  // left:-35px;
  // top: 25px;
}
</style>
